/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';
import app from 'flarum/forum/app';
import addHomeFacadeBlocks from './addHomeFacadeBlocks';
import FacadeManagerPage from './components/FacadeManagerPage';
import Banner from './models/Banner';
import LinkButton from 'flarum/common/components/LinkButton';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import { extend } from 'flarum/common/extend';
import { slug } from '../common';
import ComposeBannerPage from './components/ComposeBannerPage';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum`;

app.initializers.add(slug, () => {
	app.store.models.banners = Banner;

	app.routes['facade-manager'] = {
		path: '/facade-manager',
		component: FacadeManagerPage,
	};

	app.routes['compose-banner'] = {
		path: '/facade-manager/compose',
		component: ComposeBannerPage,
	};

	User.prototype.canManageBanners = Model.attribute('canManageBanners');

	addHomeFacadeBlocks();

	extend(SessionDropdown.prototype, 'items', (items) => {
		if (app.session?.user?.canManageBanners() && m.route.get()) {
			items.add(
				'facade-manager',
				<LinkButton href={app.route('facade-manager')} icon="far fa-store" active={m.route.get().indexOf('/facade-manager') === 0}>
					{t(`${prfx}.facade_manager.title`)}
				</LinkButton>,
				1
			);
		}
	});
});
